import { ComponentStyleConfig } from '@chakra-ui/react';

export const heading: ComponentStyleConfig = {
  variants: {
    pageTitle: {
      color: 'text.main',
      fontSize: 'md',
      fontWeight: 'semibold',
    },
    pageSubtitle: {
      color: 'text.main',
      fontSize: 'sm',
      fontWeight: 'normal',
    },
    sectionTitle: {
      color: 'text.main',
      fontSize: 'md',
      fontWeight: 'medium',
    },
  },
};
